<template>
  <div >
    <h2 style="color: #dd6161"></h2>


    <h4 style="background-color: #F56C6C;"><span style="font-weight: normal;color: #FFFFFF; ">【置顶】常见问题</span></h4>
    <p>一、导出数据操作步骤：1.选择导出项 2.同步订单  3.查看订单</p>
    <p>二、主号如何授权子号<el-button type="text" @click="help">查看</el-button></p>
    <h3>软件说明</h3>
    <h4>一、关于升级</h4>
    <p style="font-weight: bold;color: #3a8ee6">1、之前订购的基础版，如果需要升级到高级版，直接订购高级版，付款时只需支付差价。</p>
    <h4>二、简要说明</h4>
    <p>1、之前订购的基础版，如果需要升级到高级版，直接订购高级版，付款时只需支付差价。</p>
    <p>2、试用版用户只可查看最近7天的数据。</p>
    <p>3、高级版支持子号登录，登录前主号先给子号授权。</p>
    <p>4、高级版可同步商品信息，设置商品简称，成本。</p>
    <p>5、高级版可批量导入快递单，批量发货。</p>
    <p>6、高级版可生成配货单， 查看某款的销量，软件按颜色尺码属性进行统计汇总</p>
    <p>7、子号没有相关功能操作权限，主号需要通过权限管理模块授权子号软件可用的功能。</p>


    <div align="left" style="margin-top: 200px; margin-left: 20px">
      <span style="font-size: 12px">Copyright ©2020 ZDINFO.TOP 版权所有
        <el-link href="https://beian.miit.gov.cn/"  type="primary" style="margin-left: 10px;font-size: 12px">豫ICP备17046731号</el-link></span>
    </div>

    <el-dialog
      title="续费提醒二"
      :visible.sync="showAd"
      width="650px"
      center>


      <p> <span style="font-size:14pt; color:red">6月16日 - 7月31日 期间无法续费</span>  </p>
      <p> <span style="font-size:14pt; color:red">请到期时间在60天以内的用户及时续费， </span> <span style="font-size:16pt; color:red; font-weight: bold">建议续费3个月 </span> </p>

      <p> <span style="font-size:16pt; color:red">【到期时间】{{deadline}} </span> </p>
      <p>
        <el-link  style="font-size: 20px" type="primary" target="_blank" href="https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24407">
          续费链接</el-link> </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAd = false">确 定</el-button>
        <el-button type="success" @click="closeConfirm">我已知晓，不再提示</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {Decrypt,Encrypt} from '../api/utils.js'

    export default {
      name: "Index",

      data() {
        return {
          //http://www.360doc.com/content/22/0813/23/276037_1043690240.shtml  GIF 制作
          //https://www.jb51.net/article/135956.htm  图片路径
          url: './static/image/JD.jpg',
          active: '1',
          logined:true,
          days:'0',
          isdoing: 0,
          showAd: false,
          deadline:'',
          fieldOptions : [{title:'订单号', field:'tidstr',span:1 },{title:'买家旺旺', field:'maskNick',span:1},
            {title:'拍下时间', field:'created',span:1 },{title:'付款时间', field:'payTime',span:1 },{title:'订单总价', field:'payment',span:1 },{title:'邮费', field:'postFee',span:1 },
            {title:'优惠', field:'discountFee',span:1 },{title:'收货信息', field:'maskInfo',span:1 },{title:'姓名', field:'maskName',span:1 },
            {title:'手机', field:'maskMobile',span:1 }, {title:'电话', field:'maskPhone',span:1 },{title:'收货地址', field:'addr1',span:1 },{title:'省份', field:'receiverState',span:1 },
            {title:'地市', field:'receiverCity',span:1 },{title:'区县', field:'receiverDistrict',span:1 },
            {title:'详细地址', field:'receiverAddress',span:1 },{title:'邮编', field:'receiverZip',span:1 },{title:'订单状态', field:'status',span:0},
            {title:'买家留言', field:'buyerMessage',span:1 },{title:'卖家备注', field:'sellerMemo',span:1 },{title:'备注旗帜', field:'sellerFlag',span:1},
            {title:'子订单号', field:'oidstr',span:0 },{title:'子单状态', field:'ordStts',span:0 },{title:'商品ID', field:'numIid',span:0 },
            {title:'主图', field:'picPath',span:0 },{title:'商品名称', field:'title',span:0 },{title:'宝贝简称', field:'shortName',span:0 },
            {title:'货号', field:'hh',span:10 },{title:'商家编码', field:'outerIid',span:0 },{title:'SKU商家码', field:'outerSkuId',span:0 },{title:'颜色分类', field:'skuPropertiesName',span:0 },
            {title:'商品属性', field:'outerSkuProp',span:0},{title:'颜色&尺码', field:'shortSku',span:0},
            {title:'颜色', field:'color',span:0},{title:'尺码', field:'size',span:0},{title:'属性', field:'orderAttr',span:0},{title:'数量', field:'num',span:0},
            {title:'单价', field:'price1',span:0},{title:'重量', field:'itemWeight',span:0},{title:'体积', field:'itemSz',span:0},{title:'物流单号', field:'invoiceNo',span:0},{title:'物流公司', field:'logisticsCompany',span:0},
            {title:'实付单价', field:'orderPrice',span:0},{title:'实付总价', field:'orderPay',span:0},{title:'成本价', field:'cost',span:0},{title:'利润', field:'profit',span:0},

            {title:'退款状态', field:'refundStts',span:0},{title:'退款申请时间', field:'crtRefund',span:0},{title:'更新时间', field:'mdfRefund,span:0'},{title:'退货时间', field:'goodReturnTime',span:0},
            {title:'退货物流', field:'companyName',span:0},{title:'退货单号', field:'sid',span:0},{title:'退货原因', field:'reason',span:0},{title:'退款成功时间', field:'refundOkTime',span:0},
            {title:'发货时间', field:'consignTime',span:0},{title:'确认时间', field:'endTime',span:0},{title:'支付宝交易号', field:'alipayStr',span:1},
            {title:'卖家已评', field:'sellerRate',span:0},{title:'买家已评', field:'buyerRate',span:0},{title:'退款ID', field:'refundId',span:0},{title:'退款类型', field:'hasGoodReturn',span:0},
            {title:'退款金额', field:'refundFee',span:0},  {title:'条形码', field:'barcode',span:0},{title:'税费', field:'subOrderTaxFee',span:0},{title:'阶段已付', field:'stepPaidFee',span:0},
            {title:'修改时间', field:'modified',span:0},{title:'发票抬头', field:'invoiceName',span:0},{title:'买家退货物流', field:'buyerLogisticName',span:0},{title:'买家退货单号', field:'buyerLogisticNo',span:0},

          ],
        };
      },
      methods:{
        help:function(){
          this.$router.push({name: "Help", params:{ id: 'zzh'}});
        },

        goto:function () {
          this.$router.replace({name:'Permission'})
        },
        down:function () {
          window.location.href='./static/image/jd.jpg'
        },

        indexMethod(index)
        {
          return index + 1;
        },
        moveUp:function (index, row) {
          if(index>0) {
            this.fieldOptions.splice(index, 1);
            this.fieldOptions.splice(index - 1, 0, row);
          }
        },
        moveDown:function (index, row) {
          if(index<this.fieldOptions.length-1) {
            this.fieldOptions.splice(index, 1);
            this.fieldOptions.splice(index+1, 0, row);
          }
        },
        closeConfirm(){
          storage.set("ad6","1");
          this.showAd = false;
        }
      },
      mounted(){
        let nick = storage.get("nick");
        if(nick == null){
          this.$message.error("您当前没有登录，请登录后进行操作！");
        }else {
          this.deadline = storage.get("deadline");
          let ad = storage.get("ad6");
          if((ad == null) || (ad == '0'))
            this.showAd = true;
        }
        //强制关闭广告
        this.showAd = false;

       /* let a = Encrypt("Hello world");
        console.log(a);

        // Decrypt 解密
        let b = Decrypt(a);
        console.log(b);*/
      }
    }
  /*location /api {
    rewrite ^.+api/?(.*)$ /$1 break;
    include uwsgi_params;
    proxy_pass http://ss.zdinfo.top:8081/;
      }*/
</script>

<style scoped>
  html, body {
    margin: 0;
  }

  .el-link.el-link--default {
    color: #FFF;
  }

  .link a {
    color: #ffffff;
    font-size: 12pt;
    font-weight: bold;
    text-decoration:none;
  }

</style>






// WEBPACK FOOTER //
// src/page/Index.vue